import { Button, Stack } from '@mui/material';
import { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import ScanbotSDK from 'scanbot-web-sdk/ui';

export async function startScanner() {
  const config = new ScanbotSDK.UI.Config.BarcodeScannerScreenConfiguration();
  const result = await ScanbotSDK.UI.createBarcodeScanner(config);
  return result;
}

const QRCodeScanner = () => {
  const [scanResult, setScanResult] = useState<string | null>('');
  const intl = useIntl();

  useEffect(() => {
    const initScanner = async () => {
      await ScanbotSDK.initialize({
        licenseKey: '',
        enginePath: `${window.location.origin}/wasm/`,
      });
    };

    initScanner();
  }, []);

  useEffect(() => {
    if (scanResult) {
      new URL(scanResult);
      window.location.href = scanResult;
    }
  }, [scanResult]);

  async function startScanner() {
    const config = new ScanbotSDK.UI.Config.BarcodeScannerScreenConfiguration();

    const result = await ScanbotSDK.UI.createBarcodeScanner(config);

    if (result && result.items && result.items.length > 0) {
      const barcode = result.items[0].barcode;
      if (barcode && barcode.text) {
        setScanResult(barcode.text);
      }
    }

    return result;
  }

  return (
    <Stack spacing={2}>
      <Button size="small" onClick={startScanner} variant="contained">
        {intl.formatMessage({ defaultMessage: 'Skenovat QR', id: 'clientProfilePage.scanQR' })}
      </Button>
    </Stack>
  );
};

export default QRCodeScanner;
